module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAYAAACALL/6AAAAOElEQVQYlWM8cODAfwcHBwZC4MCBAwwMDAwMTARVogEWdBOwAWQXkGzDcNAADyVi4gKuAV+QogMAqw4MWRUlAkAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/MAXIMIZE.png
// module id = 84
// module chunks = 0